<template>
  <div class="base-csv-import">
    <base-loading :waitFlg="waitFlg" />
    <h2>{{ titleText }}</h2>
    <slot :uploadCsv="uploadCsv"></slot>
    <div>
      <div>clinicId</div>
      <input type="text" v-model="clinicId" />
      <div>email</div>
      <input type="text" v-model="email" />
      <div>pass</div>
      <input type="password" v-model="pass" />
    </div>
    <base-button-medium-orange class="button" @click="confirm"
      >登録</base-button-medium-orange
    >
    <announce-popup
      v-if="announce.showFlg"
      :title="announce.title"
      :buttons="announce.buttons"
      :type="announce.type"
      :oneButtonColor="announce.buttonColor"
      @close="announceButtonAction"
      >{{ announce.message }}</announce-popup
    >
    <announce-popup
      v-if="confirmationPopup.showFlg"
      :title="confirmationPopup.title"
      :buttons="confirmationPopup.buttons"
      :type="confirmationPopup.type"
      @cancel="confirmationButtonCancel"
      @decision="confirmationButtonDecision"
      >{{ confirmationPopup.message }}</announce-popup
    >
  </div>
</template>

<script>
import Encoding from 'encoding-japanese'
import AnnouncePopup from '@/components/popups/AnnouncePopup'
import BaseButtonMediumOrange from '@/components/parts/atoms/BaseButtonMediumOrange'
import BaseLoading from '@/components/parts/atoms/BaseLoading'
import { getAxiosObject } from '@/utils/library'
export default {
  name: 'BaseCsvImport',

  components: {
    AnnouncePopup,
    BaseButtonMediumOrange,
    BaseLoading
  },

  props: {
    titleText: { type: String },
    url: { type: String },
    initialCsvData: { type: Object },
    clinics: { type: Array },
    makeConfirmText: { type: Function }
  },

  data() {
    return {
      announce: {
        showFlg: false,
        title: '',
        buttons: [],
        message: '',
        type: '',
        buttonColor: ''
      },
      confirmationPopup: {
        showFlg: false,
        title: '',
        buttons: [],
        message: '',
        type: ''
      },
      uploadFile: {},
      waitFlg: false,
      fileData: null,
      timeOut: null,
      csvData: {},
      clinicId: 0,
      email: '',
      pass: ''
    }
  },

  mounted() {
    this.csvData = { ...this.initialCsvData }
  },

  methods: {
    confirm() {
      const numberClinicId = Number(this.clinicId)
      const targetClinic = this.clinics.find(
        v => v.id === numberClinicId && v.email === this.email
      )
      if (targetClinic) {
        const text = this.makeConfirmText(targetClinic)
        this.openConfirmationPopup(text)
      } else {
        this.openErrorAnnounce('対象の医院が存在しません')
      }
    },
    async addData() {
      try {
        const axiosObject = getAxiosObject()
        const res = await axiosObject.post(this.url, {
          clinicId: this.clinicId,
          email: this.email,
          pass: this.pass,
          csvData: this.csvData
        })
        this.openSuccessAnnounce('処理が完了しました')
        this.$emit('success', res)
      } catch (error) {
        const message = this.getErrorMessage(error)
        this.openErrorAnnounce(message)
      }
    },
    getErrorMessage(error) {
      if (error.response?.data?.message === 'invalid data') {
        if (error.response?.data?.extra === 'pass') {
          return '管理パスワードのエラー'
        } else if (error.response?.data?.extra === 'not found clinic') {
          return '対象の医院が存在しません'
        } else {
          const messages = error.response?.data?.extra
            .map(v => JSON.stringify(v))
            .join('\n')
          return '入力値のエラー\n' + messages
        }
      }

      return '未分類のエラー(詳細はplus_backのconsole.logを参照)'
    },
    openSuccessAnnounce(message) {
      this.announce = {
        showFlg: true,
        title: '完了',
        buttons: ['閉じる'],
        message,
        type: 'success',
        buttonColor: 'white'
      }
    },
    openErrorAnnounce(message) {
      this.announce = {
        showFlg: true,
        title: '失敗',
        buttons: ['閉じる'],
        message,
        type: 'alert',
        buttonColor: 'white'
      }
    },
    openConfirmationPopup(message) {
      this.confirmationPopup = {
        showFlg: true,
        title: '実行確認',
        buttons: ['キャンセル', '実行'],
        message,
        type: 'alert'
      }
    },
    confirmationButtonCancel() {
      this.confirmationPopup.showFlg = false
    },
    async confirmationButtonDecision() {
      this.confirmationPopup.showFlg = false
      await this.addData()
    },
    announceButtonAction() {
      this.announce.showFlg = false
    },
    uploadCsv(e, dataName) {
      this.waitFlg = true
      this.timeOut = setTimeout(async () => {
        const res = await this.readCsv(e)
        if (res[0]) {
          this.csvData[dataName] = res[1]
        }
        this.waitFlg = false
      }, 1000)
    },
    readCsv(e) {
      return new Promise((resolve, reject) => {
        const file = e.target.files[0]
        const reader = new FileReader()
        file ? reader.readAsArrayBuffer(file) : (this.waitFlg = false)
        reader.onload = () => {
          const binary = new Uint8Array(reader.result)
          let csvStr
          switch (Encoding.detect(binary)) {
            case 'UTF8':
              csvStr = new TextDecoder().decode(binary)
              break
            case 'SJIS': {
              const utf8Array = Encoding.convert(binary, {
                to: 'UNICODE',
                from: 'SJIS'
              })
              csvStr = Encoding.codeToString(utf8Array)
              break
            }
            default: {
              csvStr = new TextDecoder().decode(binary)
              break
            }
          }
          resolve([true, csvStr])
        }
        reader.onerror = () => reject([false])
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.apply-form {
  display: flex;
  flex-direction: column;
  > .validation-observer {
    > img {
      margin-top: 20px;
    }
    > .button {
      margin: 40px 0 100px;
    }
  }
}
</style>
